import { Label } from '@pixacare/domain';

export const isLabel = (object: string | Label): object is Label => !!(object as Label).word;
